import React, { useState } from 'react'
import { validateFunctionalForm } from '../../../utils';
import { v3_add_document_comment, v3_upload_document } from '../../../actions/v3/document';
import { toast } from 'react-toastify';
import moment from 'moment';
import { v3_add_claim_comment } from '../../../actions/v3/guaranteeClaims';
import { FaPlus, FaTrash } from 'react-icons/fa';

const DocumentDetail = ({ data, refresh, setRefresh }) => {
    const [state, setState] = useState({
        comment: { name: 'comment', value: '', isRequired: true, error: '' },
        documentFiles: { name: 'documentFiles', value: [{ fileName: '', originalFileName: '' }], isRequired: true, error: '' },

    });
    const handleFileChange = (index, file) => {
        const formData = new FormData();
        formData.append('file', file);

        v3_upload_document(formData).then((res) => {
            if (res.status && res.result) {
                const updatedFiles = [...state.documentFiles.value];
                updatedFiles[index] = {
                    fileName: res.result.fileName,
                    originalFileName: res.result.originalFileName
                };

                setState(prev => ({
                    ...prev,
                    documentFiles: {
                        ...prev.documentFiles,
                        value: updatedFiles,
                        error: updatedFiles.length === 0 ? 'This field is required' : ''
                    }
                }));
            }
        });
    };
    const addFileField = () => {
        setState(prev => ({
            ...prev,
            documentFiles: {
                ...prev.documentFiles,
                value: [...prev.documentFiles.value, { fileName: '', originalFileName: '' }],
                error: ''
            }
        }));
    };

    const removeFileField = (index) => {
        const updatedFiles = state.documentFiles.value.filter((_, i) => i !== index);
        setState(prev => ({
            ...prev,
            documentFiles: {
                ...prev.documentFiles,
                value: updatedFiles,
                error: updatedFiles.length === 0 ? 'At least one document is required' : ''
            }
        }));
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({
            ...prev,
            [name]: { ...prev[name], value },
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {
                comment: state.comment.value,
                claimId: data.CLAIM_ID,
                files: state.documentFiles.value
            }
            v3_add_claim_comment(model).then((res) => {
                if (res.status) {
                    toast.success(res.result.message)
                    setRefresh(!refresh)
                    setState((prev) => ({
                        ...prev,
                        ['comment']: { ...prev['comment'], value: '' },
                    }));
                }
            })
        }
    }


    return (
        <div className="card card-right-doc-aside bsn">
            <div className="card-body pdl0 pdr0">
                <div className='right-taitlebox'>
                    <h4>{data.SUBJECT}</h4>
                    <h6>{data.HULL_NUMBER} - {data.SHIP_NAME}</h6>
                    <h6>Category - {data.CATEGORY_NAME || '-'}</h6>
                    <h6>
                        Assigned to - {data.assignees.map(item => item.FULL_NAME).join(', ')}
                    </h6>

                    <span className="badge rounded-pill bg-info"
                        style={{
                            backgroundImage:
                                "linear-gradient(90deg, #0ddcef, #319bfc)",
                            fontSize: 11
                        }}
                    >{data.STATUS}
                    </span>
                </div>
                <div className="table-responsive tableexInfo">
                    <table className="table-rev-doc table align-middle table-nowrap table-hover">
                        <thead className="table-light">
                            <tr>

                                <th scope="col">C. ID</th>
                                <th scope="col">FILES</th>
                                <th scope="col">UPLOADED</th>

                            </tr>
                        </thead>
                        <tbody>
                            {data.comments?.map((comment, idx) => {
                                if (comment.files.length > 0) {
                                    return (
                                        <tr>
                                            <td>{comment.ID}</td>
                                            <td><p className="text-muted mb-0">{comment.files.length} Files <span><a href="javascript:void(0)"><i className="fa fa-download" aria-hidden="true" style={{ color: "#f46a6a" }} ></i></a></span></p></td>
                                            <td>{moment(comment.CREATED_ON).format('DD MMM YYYY')}</td>
                                        </tr>
                                    )
                                }
                                else {
                                    return null
                                }
                            })}

                        </tbody>
                    </table>
                    <table className="table table-info-bx">
                        <tbody>
                            <tr>
                                <td><p className="text-muted mb-0"><b>Created by</b> {data.CREATED_BY_NAME}</p></td>

                            </tr>
                            <tr>
                                <td><p className="text-muted mb-0"><b>Modified On</b> {moment(data.MODIFIED_ON).format('MMM DD YYYY')}</p></td>


                            </tr>
                        </tbody>
                    </table>

                    {data.comments?.map((comment, idx) => (
                        <div key={idx} className='CommentBox'>
                            <p>{comment.COMMENT}</p>
                            <h5>Commented By: <span>{comment.COMMENTED_BY_NAME}</span></h5>
                            <h5>Date: <span>{moment(comment.CREATED_ON).format('DD MMM, YYYY')}</span></h5>

                        </div>
                    ))}




                </div>
                <form onSubmit={handleSubmit} >
                    <div className='commentsSection'>
                        {/* <h3>Add Comment</h3> */}

                        <div class="form-control1">
                            {/* <div class="label-form">Add Comment</div> */}
                            <div class="input-form ">
                                <textarea type="text" class="form-control" placeholder="Enter Comment"
                                    value={state.comment.value}
                                    name={state.comment.name}
                                    onChange={handleChange}
                                />
                            </div>

                        </div>



                    </div>

                    <div className="col-md-12 mb-3 commentsSection" >

                        <div class="input-form ">
                            <div class="label-form mb-2">Upload Documents</div>

                            {state.documentFiles.value.map((item, index) => (
                                <div key={index} className="d-flex align-items-center">
                                    {item.fileName ? (
                                        <>
                                            <div className="me-2 flex-grow-1">
                                                <span>{item.originalFileName}</span>
                                            </div>
                                            <button
                                                type="button"
                                                className="btn btn-outline-danger"
                                                onClick={() => removeFileField(index)}
                                            >
                                                <FaTrash />
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <input
                                                type="file"
                                                onChange={(e) => handleFileChange(index, e.target.files[0])}
                                                className="form-control me-2"
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-outline-danger"
                                                onClick={() => removeFileField(index)}
                                            >
                                                <FaTrash />
                                            </button>
                                        </>
                                    )}
                                </div>
                            ))}

                            {/* Add button always visible below the list */}
                            <div>
                                <button
                                    type="button"
                                    className="btn btn-outline-primary"
                                    onClick={addFileField}
                                >
                                    <FaPlus className="me-1" /> Add Document
                                </button>
                            </div>

                            {state.documentFiles.error && (
                                <div className="text-danger mt-1">{state.documentFiles.error}</div>
                            )}
                        </div>

                    </div>
                    <div className="form-group mt-2 commentsSection">
                        <button
                            className="btn btn-primary"
                            type='submit'
                            style={{ backgroundColor: '#29577b', borderColor: '#29577b' }}
                        >
                            Add Comment
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default DocumentDetail
